import {apiRequest} from "../../../utils/AxiosHelper";
import {ISSUE_TYPES, STATUS_PARAMS} from "../../../constants/constants";
import APIs from "../../../modules/settings/APIs";
import {useAppSelector} from "../../../hooks/hooks";
import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {Status} from "../../../types";

interface StatusParams {
  propertyFind?: string;
  valueFind?: string;
  propertyOrder?: string;
}

const fetchStatus = async (params: StatusParams): Promise<Status[]> => {
  const response = await apiRequest.get(APIs.parameters.common.status.list, {
    params: {
      propertyFind: params.propertyFind || STATUS_PARAMS.PROPERTY_FIND,
      valueFind: params.valueFind || ISSUE_TYPES.OPERATIONAL_RISK,
      propertyOrder: params.propertyOrder || STATUS_PARAMS.PROPERTY_ORDER
    }
  });

  return response.data.data;
};

export const useStatus = (params: StatusParams = {}, queryStatus?: Partial<UseQueryOptions<Status[], Error>>) => {
  const {isAuthenticated, token} = useAppSelector((state) => state.session);

  return useQuery({
    queryKey: ['options', params],
    queryFn: () => fetchStatus(params),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    enabled: isAuthenticated && !!token,
    ...queryStatus,
  });
};
